import Vue from 'vue';
import _axios from './axios'

Plugin.install = function(Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
      axios: {
        get() {
          return _axios;
        }
      },
      $axios: {
        get() {
          return _axios;
        }
      },
    });
  };
  
  Vue.use(Plugin)
  
  export default Plugin;


// WEBPACK FOOTER //
// ./src/plugs/axios/index.js